import '../style/tooltip-DROOFnWQ.css'
import { defineComponent as p, useAttrs as m, computed as n, openBlock as u, createBlock as g, unref as a, mergeProps as y, withCtx as i, renderSlot as l, createTextVNode as h, toDisplayString as S } from "vue";
import { omit as b } from "lodash-es";
import k from "./popper.js";
import { getSpaceValue as B } from "./utils/style.js";
const D = /* @__PURE__ */ p({
  name: "e-tooltip",
  __name: "tooltip",
  props: {
    placement: { default: "bottom" },
    transition: { default: "slide" },
    triggerByHover: { type: Boolean, default: !0 },
    toggleByClick: { type: Boolean, default: !1 },
    offsetDistance: { default: 12 },
    offsetSkid: { default: 0 },
    theme: {},
    minWidth: { default: "160px" },
    whiteSpace: {},
    disabled: { type: Boolean },
    content: {},
    contentAlign: { default: "left" },
    contentPadding: {},
    lazy: { type: Boolean, default: !0 },
    openDelay: {}
  },
  setup(r) {
    const e = r, s = m(), { minWidth: o } = e, d = b(s, ["class"]), f = n(() => e.whiteSpace ? e.whiteSpace : o === "auto" ? "nowrap" : "normal"), c = n(() => {
      const t = {
        whiteSpace: f.value
      };
      return e.contentAlign !== "left" && (t.textAlign = e.contentAlign), e.contentPadding !== void 0 && (t.padding = B(e.contentPadding)), t.width = o, t;
    });
    return (t, w) => (u(), g(a(k), y({
      arrow: "",
      variant: "tooltip"
    }, a(d), {
      placement: t.placement,
      transition: t.transition,
      "offset-distance": t.offsetDistance,
      "trigger-by-hover": t.triggerByHover,
      "toggle-by-click": t.toggleByClick,
      theme: t.theme,
      "offset-skid": t.offsetSkid,
      disabled: t.disabled,
      lazy: t.lazy,
      "content-style": c.value
    }), {
      default: i(() => [
        l(t.$slots, "default")
      ]),
      content: i(() => [
        l(t.$slots, "content", {}, () => [
          h(S(t.content), 1)
        ])
      ]),
      _: 3
    }, 16, ["placement", "transition", "offset-distance", "trigger-by-hover", "toggle-by-click", "theme", "offset-skid", "disabled", "lazy", "content-style"]));
  }
});
export {
  D as default
};
//# sourceMappingURL=tooltip.js.map
